import { toast } from "react-toastify";

const post = async ({
  actionFetch,
  data,
  urlMainEntity,
  datasAreValid,
  setPreventDraftig,
  editingRelatedEntity,
  language,
  calType,
  notEvUrl,
  forceLtr,
  isInsertAll,
  preventSuccessToast,
  isProcessual,
  noMiddleUrl,
  preventValidateErrorToast,
  noInsert,
}) => {
  let wasSuccessFull = false;
  if (editingRelatedEntity) {
    toast.error(forceLtr ? "Close editing related entity" : "ابتدا از تغییر دیتا دیگر خارج شوید");
  } else if (datasAreValid === false) {
    if (!preventValidateErrorToast)
      toast.error(forceLtr ? "Fix the form bugs first" : "ابتدا فیلدهای اشتباه را تصحیح کنید");
  } else {
    const result = await actionFetch({
      method: "POST",
      url: notEvUrl
        ? notEvUrl
        : `${isProcessual ? "processual/" : ""}${
            isInsertAll ? "insertAll/" : noInsert ? "" : "insert/"
          }${urlMainEntity}`,
      body: data,
      language,
      calType,
      notEV: notEvUrl ? true : null,
      noMiddleUrl: noMiddleUrl,
    });
    if (
      result.resIsOk &&
      result.resStatus === 200
      //  && result.response?.message === "commands done!"
    ) {
      if (setPreventDraftig) {
        setPreventDraftig(true);
      }
      if (!preventSuccessToast) {
        toast.success(forceLtr ? "Data successfully inserted" : "اطلاعات با موفقیت ثبت شد");
      }
      wasSuccessFull = true;
    } else if (result.response?.message?.toLowerCase()?.includes("duplicate")) {
      toast.error(forceLtr ? "Record already exists!" : "اطلاعات وارد شده تکراری می باشد");
    } else if (result.response?.message?.toLowerCase()?.includes("you don't have access")) {
      toast.error(forceLtr ? result.response?.message : "شما دسترسی انجام این عملیات را ندارید");
    } else {
      toast.error(forceLtr ? "your request faced a problem!" : "خطا در ثبت اطلاعات");
    }
  }
  return wasSuccessFull;
};

export default post;
